import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  title: {
    paddingBottom: theme.spacing(3),
    textTransform: 'uppercase',
    color: theme.palette.action.main,
  },
  paragraph: {
    paddingBottom: theme.spacing(3),
  },
}));
